import React from "react";
import { Container } from "react-bootstrap";
import ContactCards from "../../components/ContactCards/ContactCards";
import ContactForm from "../../components/ContactForm/ContactForm";
import Footer from "../../components/Footer/Footer";
import { StaticHero } from "../../components/StaticHero";

const ContactPage = () => {
  const heroConf = {
    title: "Contact our sales team",
    subtitle:
      "if you need our help,have questions about how to use the platform or are experiencing technical difficulties,please do not hesitate to contact us",
  };
  return (
    <div>
      <StaticHero {...heroConf} contact={true} />
      <Container className="py-5">
        <ContactForm />
      </Container>
      <ContactCards />
      <Footer />
    </div>
  );
};

export default ContactPage;
